import React from 'react';
import { Icon } from '@app/src/common/Icon';
import { Wrapper, Container, IconWrapper, Text } from './styled';
import { COLORS } from '@app/src/ui';

interface Props {
  message?: string;
  isDisplay?: boolean;
  isClosable?: boolean;
  error?: boolean;
  handleClickClose?: Function;
  className?: string;
  backgroundColor?: string;
  textColor?: string;
}

export const FlashMessage: React.FC<Props> = ({
  message,
  isClosable,
  isDisplay,
  error,
  handleClickClose,
  className, 
  backgroundColor,
  textColor
}) => (
  isDisplay ?
    <Wrapper error={error} className={className} background={backgroundColor}>
      <Container>
        <Text color={textColor}>{message}</Text>
        {
          isClosable &&
          <IconWrapper onClick={handleClickClose}>
            <Icon data-name="icon-close-bold" width="12" height="12" fill={error ? '#fff' : COLORS.YELLOW_DARK} />
          </IconWrapper>
        }
      </Container>
    </Wrapper> : null
);
